import "../../../../styles/page/order.scss";

import {Tab, TabList, TabPanel, Tabs} from "../../../common/components/Tabs.jsx";
import {TitleTab, TitleTabs} from "../../../common/components/TitleTabs.jsx";

import ContentWrapper from "../../../common/components/ContentWrapper.jsx";
import FreshFoodProductList from "./FreshFoodProductList.jsx";
import FreshFoodProductListMobile from "./FreshFoodProductListMobile.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import moment from "moment";
import {scssVariables} from "../../../common/util/config.jsx";
import {withRouter} from "react-router-dom";

class FreshFoodTemplatePage extends React.PureComponent {
    constructor(props){
        super(props);

        this.createTabPanels = this.createTabPanels.bind(this);
    }
    
    UNSAFE_componentWillMount() {
        const {
            getFreshFoodTemplates,
        } = this.props;
        getFreshFoodTemplates();
    }

    calculateInternalPanelHeight() {
        let tabPanelHeight = this.props.height;

        // Remove height of tab panel
        tabPanelHeight -= parseInt(scssVariables.menuHeightWithBorder);
        return tabPanelHeight;
    }

    createTabPanels(id, thisWeek, nextWeek, isMobile) {
        const {
            localization,
            setModal,
            templateData,
            updateTemplateQty,
        } = this.props;

        const tabPanelHeight = this.calculateInternalPanelHeight();

        const panelNode = (
            <TabPanel key={id}>
                { isMobile ? (
                    <FreshFoodProductListMobile
                        height={tabPanelHeight}
                        list={templateData.products}
                        localization={localization}
                        setModal={setModal}
                        thisWeek={thisWeek}
                        nextWeek={nextWeek}
                        template={!thisWeek && !nextWeek}
                        updateTemplateQty={updateTemplateQty}
                        templateData={templateData}
                    />
                ):(
                    <FreshFoodProductList
                        height={tabPanelHeight}
                        list={templateData.products}
                        localization={localization}
                        setModal={setModal}
                        thisWeek={thisWeek}
                        nextWeek={nextWeek}
                        template={!thisWeek && !nextWeek}
                        updateTemplateQty={updateTemplateQty}
                        templateData={templateData}
                    />)}
            </TabPanel>);

        return panelNode;
    }

    render(){
        const {
            deviceType,
            localization,
            height,
            templateData,
            showFreshFood,
        } = this.props;
         
        const firstDateOfWeek = moment(templateData.startDateFirstWeekNo).format("DD.MM.YYYY");
        const lastDateOfWeek = moment(templateData.startDateFirstWeekNo).add(6, "days").format("DD.MM.YYYY");

        const firstDateONextfWeek = moment(templateData.startDateFirstWeekNo).add(7, "days").format("DD.MM.YYYY");
        const lastDateOfNextWeek = moment(templateData.startDateFirstWeekNo).add(13, "days").format("DD.MM.YYYY");

        return deviceType=="xs" ? (
            <ContentWrapper height={height}>
                <div style={{display:"flex", height:"100%"}} >
                    <div className={"card-default"}style={{display: "flex", flexDirection:"column", flexGrow: 1, overflow: "hidden", height:height-20}}>
                        <Tabs startTabId={"1"}>
                            <TabList >
                                <Tab id={"1"} label={`Uke ${templateData.currentWeekNo}`} />
                                <Tab id={"2"} label={`Uke ${templateData.nextWeekNo}`} />
                                <Tab id={"3"} label={localization.text("order", "template", "editTemplate")} />
                            </TabList>
                            { this.createTabPanels(1, true, false, true) }
                            { this.createTabPanels(2, false, true, true) }
                            { this.createTabPanels(3, false, false, true) }
                        </Tabs>
                    </div>
                </div>
            </ContentWrapper>
        ) : (
            <ContentWrapper height={height} paddingRight={false}>
                <div style={{display:"flex", height:"100%"}} >
                    <div className="my-list-left-backgorund" >
                        <TitleTabs>
                            <TitleTab label={localization.text("order","TitleTab","Products")} url={"/order/products"} deviceType={deviceType} />
                            <TitleTab label={localization.text("order","TitleTab","Campaigns")} url={"/order/campaigns"} deviceType={deviceType} />        
                            <TitleTab label={localization.text("order","TitleTab","List")} url={"/order/lists"} deviceType={deviceType} />
                            { showFreshFood && (
                                <TitleTab label={localization.text("order","TitleTab","FreshFoodTemplate")} url={"/order/freshfoodTemplate"} deviceType={deviceType} />
                            )} 
                        </TitleTabs>
                        <div className={"card-default"} style={{ display: "flex", flexDirection: "column", height: `${height-106}px` }}>
                            <Tabs startTabId={"1"}>
                                <TabList >
                                    <Tab id={"1"} label={`Uke ${templateData.currentWeekNo}: ${firstDateOfWeek} - ${lastDateOfWeek}`} />
                                    <Tab id={"2"} label={`Uke ${templateData.nextWeekNo}: ${firstDateONextfWeek} - ${lastDateOfNextWeek}`} />
                                    <Tab id={"3"} label={localization.text("order", "template", "editTemplate")} />
                                </TabList>
                                { this.createTabPanels(1, true, false, false) }
                                { this.createTabPanels(2, false, true, false) }
                                { this.createTabPanels(3, false, false, false) }
                            </Tabs>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        );
    }
}

FreshFoodTemplatePage.propTypes = {
    //Required
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    setDropDown: PropTypes.func.isRequired,
    getFreshFoodTemplates: PropTypes.func.isRequired,
    templateData: PropTypes.object.isRequired,
    updateTemplateQty : PropTypes.func.isRequired,
    setModal: PropTypes.func,
    showFreshFood: PropTypes.bool.isRequired,
};

export default withRouter(FreshFoodTemplatePage);